import { cats } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-12 md:px-6 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="今天吃瓜首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-black tracking-tight text-foreground-950">今天吃瓜</span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            实时更新一手热点与八卦动态的资讯站，滚动播报最新瓜料、娱乐与话题进展，随点随看，不错过任何一条新鲜爆料。
          </p>
          <div className="mt-5 flex items-center gap-2">
            <a href="#subscribe" aria-label="关注" className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition hover:bg-primary-500 hover:text-background-50"><i className="ri-weibo-line"></i></a>
            <a href="#subscribe" aria-label="关注" className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition hover:bg-primary-500 hover:text-background-50"><i className="ri-bilibili-line"></i></a>
            <a href="#subscribe" aria-label="关注" className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition hover:bg-primary-500 hover:text-background-50"><i className="ri-wechat-line"></i></a>
          </div>
        </div>

        <nav aria-label="栏目导航">
          <h3 className="text-sm font-black text-foreground-950">热门栏目</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2.5">
            {cats.map((c) => (
              <li key={c.name}>
                <a href="#topics" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">{c.name}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="页面导航">
          <h3 className="text-sm font-black text-foreground-950">本站导航</h3>
          <ul className="mt-4 space-y-2.5">
            <li><a href="#feed" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">实时热榜</a></li>
            <li><a href="#fresh" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">今日更新</a></li>
            <li><a href="#focus" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">深读专题</a></li>
            <li><a href="#about" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">吃瓜问答</a></li>
            <li><a href="#subscribe" className="whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-600">投稿与订阅</a></li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-300">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 今天吃瓜 · 仅供演示，内容为编辑甄别整理，动态随时更新。</p>
          <p className="whitespace-nowrap">信息透明 · 来源可溯 · 实时跟进</p>
        </div>
      </div>
    </footer>
  );
}